/**
 * Map lookup key → GrowthBook SDK client key.
 * Keys match `window.siteDomain` or `hostname + pathname` (no trailing slash on path), lowercase.
 * Example: `modernize.com/quote/siding`
 */
export const CLIENT_KEYS_BY_DOMAIN = {
	'affordablestairliftsolutions.com': 'sdk-7VuD5XttmY959WLi',
	'airconditioningpros.org': 'sdk-0mOI0jBFlRDfH6T',
	'americanhomewarranty.org': 'sdk-DJJ7RZdoywNdl6ih',
	'gutterspricing.com': 'sdk-DltjsRDYkh4GeuW8',
	'homewindowprices.org': 'sdk-NmFGdtPo8heOIFvg',
	'modernize.com/my/project-*': 'sdk-lezKr97OduZhps9q',
	'modernize.com/quote/cost-calculator/showers': 'sdk-iz8NAeVyu7FSk4b2',
	'modernize.com/quote/widgets/lead-form': 'sdk-1EZ2dTqwvQxCYJw',
	'topgutterpros.com': 'sdk-E0KPKeshYIruhk'
};

/**
 * `hostname` + `pathname` with trailing slash on pathname removed; root path → hostname only.
 * @returns {string} - Current host plus pathname (no trailing slash), or hostname alone on root path.
 */
function buildClientKeyLookupFromLocation() {
	const { hostname, pathname } = window.location;
	const pathWithoutTrailingSlash = pathname.replace(/\/$/, '');
	if (!pathWithoutTrailingSlash) {
		return hostname;
	}
	return `${hostname}${pathWithoutTrailingSlash}`;
}

/**
 * @param {string} [explicitKey] - from initGrowthBook({ clientKey })
 * @returns {string} - Resolved GrowthBook SDK client key, or empty string if none applies.
 */
export default function resolveGrowthBookClientKey(explicitKey) {
	if (explicitKey) {
		return explicitKey;
	}
	if (typeof window === 'undefined') {
		return '';
	}

	const rawKey = typeof window.siteDomain === 'string' && window.siteDomain.trim() !== '' ? window.siteDomain.trim() : buildClientKeyLookupFromLocation();
	const lookupKey = rawKey.toLowerCase();
	return CLIENT_KEYS_BY_DOMAIN[lookupKey] || '';
}
